var $c08e84f882644048$exports = {};
$c08e84f882644048$exports = {
  "removeButtonLabel": "\u524A\u9664",
  "removeDescription": "\u30BF\u30B0\u3092\u524A\u9664\u3059\u308B\u306B\u306F\u3001Delete \u30AD\u30FC\u3092\u62BC\u3057\u307E\u3059\u3002"
};
export { $c08e84f882644048$exports as default };